module.exports = __webpack_public_path__ + "img/logo.f113441c.webp";